import { useState } from "react";
import { api, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Loader2, AlertTriangle } from "lucide-react";
import { toast } from "sonner";

const PHRASE = "DELETE ALL DATA";

export default function DangerZone() {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);

  const reset = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/admin/reset-data", { confirm: text });
      const n = Object.values(data.deleted).reduce((a, b) => a + b, 0);
      toast.success(`All business data cleared (${n} records)`); setText("");
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); } finally { setBusy(false); }
  };

  return (
    <div className="bg-white border border-rose-200 rounded-lg p-5" data-testid="danger-zone">
      <div className="font-heading font-bold text-rose-700 flex items-center gap-2"><AlertTriangle className="h-4 w-4" /> Danger zone</div>
      <div className="text-xs text-gray-600 mt-1 mb-3">Permanently deletes all leads, deals, properties, consultants, owners, timeline events, notifications, insights, sync logs and uploaded file records. User accounts, pipeline stages and Google Sheets settings are kept. This can't be undone.</div>
      <div className="flex gap-2">
        <Input placeholder={`Type ${PHRASE} to confirm`} value={text} onChange={(e) => setText(e.target.value)} className="h-9 max-w-xs" data-testid="reset-confirm-input" />
        <Button variant="destructive" size="sm" onClick={reset} disabled={text !== PHRASE || busy} data-testid="reset-data-btn">{busy && <Loader2 className="h-4 w-4 animate-spin" />} Delete all business data</Button>
      </div>
    </div>
  );
}
